<section class="dashboard-home-screen">
    <div class="dashboard-title-row">
        <h2 class="dashboard-page-title">Home</h2>
        @if (businessUnitOptions.length > 0) {
            <div class="switch-tabs business-unit-switch-tabs">
                @for (unit of businessUnitOptions; track unit.id) {
                    <button
                        type="button"
                        [class.active]="selectedBusinessUnitId === unit.id"
                        (click)="setBusinessUnit(unit.id)">
                        {{ unit.displayName }}
                    </button>
                }
            </div>
        }
    </div>

    @if (loading) {
        <div class="dashboard-placeholder">Loading dashboard...</div>
    } @else if (errorMessage) {
        <div class="dashboard-placeholder dashboard-error">{{ errorMessage }}</div>
    } @else {
        <div class="dashboard-stack">
            <section class="dashboard-section">
                <div class="section-head">
                    <p class="section-title">All Active Projects</p>
                </div>

                <div class="projects-table">
                    <div class="projects-head">
                        <div class="col expander-col">
                            <button type="button" class="grid-toggle-icon-btn" (click)="toggleActiveProjectsSection()">
                                <i class="ri-arrow-down-s-line" [class.expanded]="showActiveProjects"></i>
                            </button>
                        </div>
                        <div class="col project-col">Project</div>
                        <div class="col pnum-col">TMEIC P#s (EQ, CX, WR)</div>
                        <div class="col sm-col">Site Manager/Field Lead</div>
                        <div class="col address-col">Site Address</div>
                    </div>

                    @if (showActiveProjects) {
                    @for (project of activeProjects; track trackByProjectId($index, project)) {
                        <div class="project-row-wrap">
                            <button type="button" class="project-row" (click)="toggleActiveProject(project.projectId)">
                                <div class="col expander-col">
                                    <i class="ri-arrow-down-s-line row-arrow" [class.expanded]="expandedActiveProjectId === project.projectId"></i>
                                </div>
                                <div class="col project-col project-name-wrap">
                                    @if (getProjectStatusIndicatorClass(project)) {
                                        <span
                                            class="project-status-indicator"
                                            [ngClass]="getProjectStatusIndicatorClass(project)"
                                            [title]="getProjectStatusIndicatorLabel(project)"
                                            aria-hidden="true">
                                        </span>
                                    }
                                    <span class="project-name">{{ project.projectName }}</span>
                                </div>
                                <div class="col pnum-col row-value">{{ getProjectNumbers(project) }}</div>
                                <div class="col sm-col row-value">{{ getCollapsedSiteManager(project) }}</div>
                                <div class="col address-col row-value">{{ getSafeValue(project.siteAddress) }}</div>
                            </button>

                            @if (expandedActiveProjectId === project.projectId) {
                                <div class="project-detail-wrap">
                                    @if (detailLoadingById[project.projectId]) {
                                        <div class="project-detail-state">Loading project details...</div>
                                    } @else if (detailErrorById[project.projectId]) {
                                        <div class="project-detail-state project-detail-error">{{ detailErrorById[project.projectId] }}</div>
                                    } @else if (getDetail(project.projectId); as detail) {
                                        <div class="project-detail-blocks">
                                            <div class="project-detail-grid">
                                                <div class="detail-item">
                                                    <p class="detail-label">Customer</p>
                                                    <p class="detail-value">{{ getSafeValue(detail.customerName) }}</p>
                                                </div>
                                                <div class="detail-item">
                                                    <p class="detail-label">End User</p>
                                                    <p class="detail-value">{{ getSafeValue(detail.endUserName) }}</p>
                                                </div>
                                                <div class="detail-item">
                                                    <p class="detail-label">Site Contact</p>
                                                    <p class="detail-value">{{ getSafeValue(detail.siteContact) }}</p>
                                                </div>
                                                <div class="detail-item">
                                                    <p class="detail-label">Customer Contact</p>
                                                    <p class="detail-value">{{ getSafeValue(detail.customerContactNumber) }}</p>
                                                </div>
                                                <div class="detail-item">
                                                    <p class="detail-label">Customer Email</p>
                                                    <p class="detail-value">{{ getSafeValue(detail.customerEmailAddress) }}</p>
                                                </div>
                                                <div class="detail-item">
                                                    <p class="detail-label">Project Address</p>
                                                    <p class="detail-value">{{ getSafeValue(detail.siteAddress) }}</p>
                                                </div>
                                            </div>

                                            <div class="project-detail-grid">
                                                <div class="detail-item">
                                                    <p class="detail-label">TMCA Ops PM</p>
                                                    <p class="detail-value">{{ getSafeValue(detail.projectManager) }}</p>
                                                </div>
                                                <div class="detail-item">
                                                    <p class="detail-label">Site Manager</p>
                                                    <p class="detail-value">{{ getSafeValue(detail.siteManagers.join(', ')) }}</p>
                                                </div>
                                                <div class="detail-item">
                                                    <p class="detail-label">Field Lead</p>
                                                    <p class="detail-value">{{ getSafeValue(detail.fieldLeads.join(', ')) }}</p>
                                                </div>
                                                @if (!isGiProject(detail)) {
                                                    <div class="detail-item">
                                                        <p class="detail-label">MVPS Config</p>
                                                        <p class="detail-value">{{ formatSkidConfiguration(detail.skidConfiguration) }}</p>
                                                    </div>
                                                    <div class="detail-item">
                                                        <p class="detail-label">Inv Model</p>
                                                        <p class="detail-value">{{ getSafeValue(detail.inverterModel) }}</p>
                                                    </div>
                                                    <div class="detail-item">
                                                        <p class="detail-label">XFMR Model</p>
                                                        <p class="detail-value">{{ getSafeValue(detail.transformerModel) }}</p>
                                                    </div>
                                                }
                                                <div class="detail-item">
                                                    <p class="detail-label">PWA Site Indicator</p>
                                                    <p-toggleswitch [ngModel]="detail.isPwaSite" [disabled]="true" />
                                                </div>
                                            </div>

                                            <div class="detail-completion-grid">
                                                <div class="detail-item">
                                                    <p class="detail-label">Checklist Verified</p>
                                                    <p class="detail-value">
                                                        {{ detail.completion.verified }} / {{ detail.completion.total }}
                                                        ({{ getPercent(detail.completion.verifiedPercentage) }})
                                                    </p>
                                                </div>
                                                <div class="detail-item">
                                                    <p class="detail-label">Checklist Not Verified</p>
                                                    <p class="detail-value">
                                                        {{ detail.completion.notVerified }} / {{ detail.completion.total }}
                                                        ({{ getPercent(detail.completion.notVerifiedPercentage) }})
                                                    </p>
                                                </div>
                                            </div>

                                            @if (canView('COMPLETION_BY_PHASE')) {
                                            <div class="phase-wrap">
                                                <p class="detail-subtitle">Completion By Phase</p>
                                                <div class="phase-grid">
                                                    @for (phase of detail.phaseCompletion; track phase.phase) {
                                                        <div class="phase-item">
                                                            <p class="phase-name">{{ phase.phase }}</p>
                                                            <p class="phase-value">{{ phase.verified }} / {{ phase.total }} ({{ getPercent(phase.verifiedPercentage) }})</p>
                                                        </div>
                                                    } @empty {
                                                        <div class="phase-item">
                                                            <p class="phase-name">No phase data</p>
                                                            <p class="phase-value">-</p>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            }

                                            @if (canView('PROJECT_SPECIFIC_ACTIVE_USERS')) {
                                            <div class="users-wrap">
                                                <p class="detail-subtitle">Project Field Resources</p>
                                                <div class="users-grid">
                                                    <div class="users-head">
                                                        <div>Name</div>
                                                        <div>Role</div>
                                                        <div>Email</div>
                                                        <div>Phone</div>
                                                        <div>City / State</div>
                                                    </div>
                                                    @for (user of detail.activeUsers; track user.userId) {
                                                        <div class="users-row">
                                                            <div>{{ getSafeValue(user.fullName) }}</div>
                                                            <div>{{ getSafeValue(user.roleName) }}</div>
                                                            <div>{{ getSafeValue(user.email) }}</div>
                                                            <div>{{ getSafeValue(user.phoneNumber) }}</div>
                                                            <div>{{ getSafeValue(user.city) }} / {{ getSafeValue(user.state) }}</div>
                                                        </div>
                                                    } @empty {
                                                    <div class="users-empty">No active field users found.</div>
                                                    }
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    } @empty {
                        <div class="dashboard-placeholder">No active projects found.</div>
                    }
                    }
                </div>
            </section>

            <section class="dashboard-progress-grid">
                @if (canView('INTEGRATION_PROGRESS')) {
                <article class="progress-card integration-card">
                    <header class="progress-card-head integration-head">
                        <div class="progress-title-wrap">
                            <i class="ri-git-branch-line"></i>
                            <p class="progress-title">Integration Progress</p>
                        </div>
                    </header>
                    <div class="progress-card-body">
                        @for (project of activeProjects; track trackByProjectId($index, project)) {
                            <div class="progress-project">
                                <button type="button" class="progress-project-head" (click)="toggleIntegrationProject(project.projectId)">
                                    <span>{{ project.projectName }}</span>
                                    <i class="ri-arrow-down-s-line" [class.expanded]="expandedIntegrationProjectId === project.projectId"></i>
                                </button>
                                @if (expandedIntegrationProjectId === project.projectId) {
                                    <div class="progress-rows">
                                        @for (row of getIntegrationRows(project.projectId); track row.label) {
                                            <div class="progress-row">
                                                <span>{{ row.label }}</span>
                                                <strong>{{ row.count }}</strong>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </article>
                }

                @if (canView('CUSTOMER_PROGRESS')) {
                <article class="progress-card customer-card">
                    <header class="progress-card-head customer-head">
                        <div class="progress-title-wrap">
                            <i class="ri-user-line"></i>
                            <p class="progress-title">Customer Progress</p>
                        </div>
                    </header>
                    <div class="progress-card-body">
                        @for (project of activeProjects; track trackByProjectId($index, project)) {
                            <div class="progress-project">
                                <button type="button" class="progress-project-head" (click)="toggleCustomerProject(project.projectId)">
                                    <span>{{ project.projectName }}</span>
                                    <i class="ri-arrow-down-s-line" [class.expanded]="expandedCustomerProjectId === project.projectId"></i>
                                </button>
                                @if (expandedCustomerProjectId === project.projectId) {
                                    @for (template of getCustomerTemplates(project.projectId); track template.projectTemplateId) {
                                        <div class="progress-project progress-project-nested">
                                            <button type="button" class="progress-project-head" (click)="toggleCustomerTemplate(project.projectId, template.projectTemplateId)">
                                                <span>{{ template.templateName }}</span>
                                                <i class="ri-arrow-down-s-line" [class.expanded]="expandedCustomerTemplateIdByProject[project.projectId] === template.projectTemplateId"></i>
                                            </button>
                                            @if (expandedCustomerTemplateIdByProject[project.projectId] === template.projectTemplateId) {
                                                <div class="progress-rows">
                                                    @for (row of getCustomerRows(project.projectId, template.projectTemplateId); track row.label) {
                                                        <div class="progress-row">
                                                            <span>{{ row.label }}</span>
                                                            <strong>{{ row.count }}</strong>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                }
                            </div>
                        }
                    </div>
                </article>
                }

                @if (canView('COMMISSIONING_PROGRESS')) {
                <article class="progress-card commission-card">
                    <header class="progress-card-head commission-head">
                        <div class="progress-title-wrap">
                            <i class="ri-bill-line"></i>
                            <p class="progress-title">Commissioning Progress</p>
                        </div>
                    </header>
                    <div class="progress-card-body">
                        @for (project of activeProjects; track trackByProjectId($index, project)) {
                            <div class="progress-project">
                                <button type="button" class="progress-project-head" (click)="toggleCommissionProject(project.projectId)">
                                    <span>{{ project.projectName }}</span>
                                    <i class="ri-arrow-down-s-line" [class.expanded]="expandedCommissionProjectId === project.projectId"></i>
                                </button>
                                @if (expandedCommissionProjectId === project.projectId) {
                                    <div class="progress-rows">
                                        @for (row of getCommissionRows(project.projectId); track row.label) {
                                            <div class="progress-row commission-progress-row">
                                                <div class="commission-progress-top">
                                                    <span>{{ row.label }}</span>
                                                    <strong>{{ row.value }}</strong>
                                                </div>
                                                <div class="commission-progress-track">
                                                    <span
                                                        class="commission-progress-fill"
                                                        [style.width.%]="getCommissionProgressPercent(row.value)">
                                                    </span>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </article>
                }
            </section>

            @if (canView('MAN_HOURS')) {
            <section class="chart-card">
                <div class="chart-header">
                    <p class="chart-title">Man Hours</p>
                    <div class="chart-header-actions">
                        <div class="manhours-category-filter">
                            <p-multiselect
                                [options]="getManHoursCategoryOptions()"
                                [(ngModel)]="selectedManHoursCategories"
                                (ngModelChange)="onManHoursCategorySelectionChange()"
                                optionLabel="label"
                                optionValue="value"
                                [placeholder]="'Categories'"
                                appendTo="body"
                                [showClear]="true"
                                [maxSelectedLabels]="2"
                                [scrollHeight]="'240px'"
                                panelStyleClass="manhours-category-multiselect-panel"
                                styleClass="manhours-category-multiselect">
                                <ng-template pTemplate="item" let-option>
                                    <div class="manhours-option-item">
                                        <span class="manhours-option-dot" [style.background]="getManHoursSeriesColor(option.value)"></span>
                                        <span>{{ option.label }}</span>
                                    </div>
                                </ng-template>
                            </p-multiselect>
                        </div>
                        <div class="date-range-control">
                            <button type="button" class="chart-btn" (click)="toggleDateRange('manHours')">
                                {{ getDateRangeLabel('manHours') }} <i class="ri-calendar-line"></i>
                            </button>
                            @if (isDateRangeOpen('manHours')) {
                                <div class="date-range-popover">
                                    <label class="date-field">
                                        <span>Start Date</span>
                                        <input type="date" [value]="dateRangeDraft.startDate" (input)="onDateRangeInput('startDate', $any($event.target).value)">
                                    </label>
                                    <label class="date-field">
                                        <span>End Date</span>
                                        <input type="date" [value]="dateRangeDraft.endDate" (input)="onDateRangeInput('endDate', $any($event.target).value)">
                                    </label>
                                    @if (dateRangeError) {
                                        <p class="date-range-error">{{ dateRangeError }}</p>
                                    }
                                    <div class="date-range-actions">
                                        <button type="button" class="chart-btn chart-btn-light" (click)="closeDateRange()">Cancel</button>
                                        <button type="button" class="chart-btn" [disabled]="!canApplyDateRange()" (click)="applyDateRange()">Apply</button>
                                    </div>
                                </div>
                            }
                        </div>
                        <button type="button" class="chart-btn" (click)="downloadManHours()"><i class="ri-download-line"></i> Download</button>
                    </div>
                </div>
                <div class="man-hours-chart-wrapper">
                    <p-chart
                        type="line"
                        [data]="manHoursChartData"
                        [options]="manHoursChartOptions"
                        [style]="{ height: '220px' }">
                    </p-chart>
                </div>
            </section>
            }

            @if (canView('EQUIPMENT_PROGRESS_GRAPH')) {
            <section class="chart-card">
                <div class="chart-header">
                    <p class="chart-title">Equipment Progress Graph</p>
                    <div class="chart-header-actions equipment-header-actions">
                        <div class="equipment-template-filter">
                            <p-multiselect
                                [options]="getEquipmentTemplateOptions()"
                                [(ngModel)]="selectedEquipmentTemplateGroups"
                                (ngModelChange)="onEquipmentTemplateSelectionChange()"
                                optionLabel="label"
                                optionValue="value"
                                [placeholder]="'Templates'"
                                appendTo="body"
                                [showClear]="true"
                                [maxSelectedLabels]="2"
                                [scrollHeight]="'300px'"
                                panelStyleClass="equipment-template-multiselect-panel"
                                styleClass="equipment-template-multiselect">
                            </p-multiselect>
                        </div>
                        <div class="date-range-control">
                            <button type="button" class="chart-btn" (click)="toggleDateRange('equipment')">
                                {{ getDateRangeLabel('equipment') }} <i class="ri-calendar-line"></i>
                            </button>
                            @if (isDateRangeOpen('equipment')) {
                                <div class="date-range-popover">
                                    <label class="date-field">
                                        <span>Start Date</span>
                                        <input type="date" [value]="dateRangeDraft.startDate" (input)="onDateRangeInput('startDate', $any($event.target).value)">
                                    </label>
                                    <label class="date-field">
                                        <span>End Date</span>
                                        <input type="date" [value]="dateRangeDraft.endDate" (input)="onDateRangeInput('endDate', $any($event.target).value)">
                                    </label>
                                    @if (dateRangeError) {
                                        <p class="date-range-error">{{ dateRangeError }}</p>
                                    }
                                    <div class="date-range-actions">
                                        <button type="button" class="chart-btn chart-btn-light" (click)="closeDateRange()">Cancel</button>
                                        <button type="button" class="chart-btn" [disabled]="!canApplyDateRange()" (click)="applyDateRange()">Apply</button>
                                    </div>
                                </div>
                            }
                        </div>
                        <button type="button" class="chart-btn" (click)="downloadEquipmentProgress()"><i class="ri-download-line"></i> Download</button>
                    </div>
                </div>
                @if (getEquipmentProjects().length === 0) {
                    <div class="progress-state">No equipment progress data.</div>
                } @else {
                    <div class="equipment-chart-wrapper">
                        <div class="equipment-chart-inner" [style.min-width.px]="getEquipmentChartMinWidthPx()">
                            <p-chart
                                type="bar"
                                [data]="equipmentChartData"
                                [options]="equipmentChartOptions"
                                [style]="{ height: '260px', width: '100%' }">
                            </p-chart>
                        </div>
                    </div>
                }
            </section>
            }

            @if (canView('TOP_RECURRING_FAILURE')) {
            <section class="chart-card">
                <div class="chart-header">
                    <p class="chart-title">Top Recurring Failure Modes</p>
                    <div class="chart-header-actions">
                        <div class="date-range-control">
                            <button type="button" class="chart-btn" (click)="toggleDateRange('failureModes')">
                                {{ getDateRangeLabel('failureModes') }} <i class="ri-calendar-line"></i>
                            </button>
                            @if (isDateRangeOpen('failureModes')) {
                                <div class="date-range-popover">
                                    <label class="date-field">
                                        <span>Start Date</span>
                                        <input type="date" [value]="dateRangeDraft.startDate" (input)="onDateRangeInput('startDate', $any($event.target).value)">
                                    </label>
                                    <label class="date-field">
                                        <span>End Date</span>
                                        <input type="date" [value]="dateRangeDraft.endDate" (input)="onDateRangeInput('endDate', $any($event.target).value)">
                                    </label>
                                    @if (dateRangeError) {
                                        <p class="date-range-error">{{ dateRangeError }}</p>
                                    }
                                    <div class="date-range-actions">
                                        <button type="button" class="chart-btn chart-btn-light" (click)="closeDateRange()">Cancel</button>
                                        <button type="button" class="chart-btn" [disabled]="!canApplyDateRange()" (click)="applyDateRange()">Apply</button>
                                    </div>
                                </div>
                            }
                        </div>
                        <button type="button" class="chart-btn" (click)="downloadRecurringFailureModes()"><i class="ri-download-line"></i> Download</button>
                    </div>
                </div>
                <div class="failure-table-wrap">
                    <div class="failure-head">
                        <div>Problem/Code Details</div>
                        <div>No. of Occurrences</div>
                        <div>Last Reported</div>
                    </div>
                    @for (row of recurringFailureModes; track row.problemCodeDetails + '-' + $index) {
                        <div class="failure-row-wrap">
                            <button type="button" class="failure-row" (click)="toggleFailureModeRow(row, $index)">
                                <div class="failure-mode-cell">
                                    <i class="ri-arrow-down-s-line row-arrow" [class.expanded]="isFailureModeExpanded(row, $index)"></i>
                                    <span class="failure-mode-text">{{ row.problemCodeDetails }}</span>
                                </div>
                                <div>{{ row.occurrences }}</div>
                                <div>{{ formatReportedOn(row.lastReportedOn) }}</div>
                            </button>

                            @if (isFailureModeExpanded(row, $index)) {
                                <div class="failure-projects-wrap">
                                    <div class="failure-project-head">
                                        <div>Project</div>
                                        <div>Occurrences</div>
                                        <div>Last Reported</div>
                                    </div>
                                    @for (project of row.projects; track project.projectId) {
                                        <div class="failure-project-row">
                                            <div>{{ project.projectName }}</div>
                                            <div>{{ project.occurrences }}</div>
                                            <div>{{ formatReportedOn(project.lastReportedOn) }}</div>
                                        </div>
                                    } @empty {
                                        <div class="failure-project-empty">No project breakdown available.</div>
                                    }
                                </div>
                            }
                        </div>
                    } @empty {
                        <div class="failure-empty-row">
                            <div>No recurring failure modes found.</div>
                        </div>
                    }
                </div>
            </section>
            }
        </div>
    }
</section>

